import { Server } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const ServerIcon = DeckardIconWrapper({ Icon: Server });
